//requireでファイルが見つからなかった時に発生するエラーを判別する
export function isCannotFindModule(error: unknown): error is Error {
  return error instanceof Error && !!error.message.match(/^Cannot find module/g);
}
